import type { BatMetadataConfigEntry } from './common/types';
import { coreFields } from './common/coreFields';
import { ceeElectricityUsageFields } from './common/electricityFields';
import { msg } from '@lingui/core/macro';

export const ceeElectricityUsageMetadata = {
  displayName: msg({
    message: 'CEE Electricity Usage',
    context: 'Activity data schema name for CEE Electricity Usage',
  }),
  fields: {
    ...coreFields,
    ...ceeElectricityUsageFields,
  },
} as const satisfies BatMetadataConfigEntry;
